import { defineComponent, computed } from 'vue';
import { EditorNodeEmptyState, PlaceholderHelper, Context } from '@getaccept/editor-lib-new';
import { t } from '@getaccept/lib-shared-new/src/helpers/translation.helper';
export default defineComponent({
    components: {
        EditorNodeEmptyState,
    },
    props: {
        node: {
            type: Object,
            default: () => ({}),
        },
    },
    setup(props) {
        const elementIcon = computed(() => PlaceholderHelper.getElementIcon(props.node));
        const heading = computed(() => PlaceholderHelper.getElementHeading(props.node, Context.DsrPublished));
        return {
            t,
            elementIcon,
            heading,
        };
    },
});
